import { Component } from "react"
import PropTypes from "prop-types"
import moment from "moment"

import Modal from "shared/components/modal"
import { reportChannelFeedbackAbuse } from "shared/lib/graphql"
import { rejectedXHRPromiseLogger } from "shared/lib/xhr_promise"
import displayFlash from "partners/scripts/display_flash"
import thumbsUp from "images/partners/feedback/thumbs-up.svg"
import thumbsDown from "images/partners/feedback/thumbs-down.svg"
import "./platform_feedback.scss"

export default class PlatformFeedbackCard extends Component {
  state = {
    modalOpen: false,
    reported: false,
  }

  opinionCodeMap = {
    not_useful: "Not useful",
    too_slow: "Too slow",
    unexpected: "Doesn't work as expected",
  }

  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen })
  }

  reportFeedback = () => {
    const { feedbackType, id } = this.props
    reportChannelFeedbackAbuse(feedbackType, id, false)
      .then(() => {
        this.setState({ modalOpen: false, reported: true }, () => {
          displayFlash("Feedback has been reported")
        })
      })
      .catch(
        rejectedXHRPromiseLogger(() => {
          displayFlash(
            "An error has occurred please contact an administrator",
            "error"
          )
        })
      )
  }

  renderAppletFeedbackResponse = () => {
    const { feedbackType, like } = this.props
    if (feedbackType === "applet_feedback") {
      if (like) {
        return (
          <span
            className="thumbs up"
            styleName="thumbs up"
            dangerouslySetInnerHTML={{ __html: thumbsUp }}
          />
        )
      }
      return (
        <span
          className="thumbs down"
          styleName="thumbs down"
          dangerouslySetInnerHTML={{ __html: thumbsDown }}
        />
      )
    }

    return null
  }

  render() {
    if (this.state.reported) {
      return null
    }

    const {
      profileImgUrl,
      userLogin,
      text,
      createdAt,
      channelInfo,
      contextChannelPublished,
      feedbackType,
      like,
      opinionCode,
      userProfileLink,
    } = this.props

    return (
      <div
        className="platform-feedback-card"
        styleName="platform-feedback-card"
      >
        <div className="feedback-card-header" styleName="feedback-card-header">
          <span
            className="feedback-header-container"
            styleName="feedback-header-container"
          >
            <a href={userProfileLink}>
              <span
                style={{
                  backgroundImage: `url(${
                    profileImgUrl || window.App.defaultProfileIconUrl
                  })`,
                }}
              />
            </a>
            <b>{userLogin}</b>
            {contextChannelPublished && channelInfo && (
              <span
                className="channel-info-container"
                styleName="channel-info-container"
              >
                with
                <span
                  style={{
                    backgroundColor: `#${channelInfo.brand_color}`,
                  }}
                >
                  <img
                    src={channelInfo.monochrome_image_url}
                    alt={channelInfo.name}
                    title={channelInfo.name}
                  />
                  {channelInfo.name}
                </span>
              </span>
            )}
          </span>
          <span
            className="feedback-header-container"
            styleName="feedback-header-container"
          >
            <span className="timestamp" styleName="timestamp">
              {moment(new Date(createdAt), "YYYYMMDD").fromNow()}
            </span>
            <span
              className="report-tag"
              styleName="report-tag"
              onClick={this.toggleModal}
            >
              Report
            </span>
          </span>
        </div>
        <div className="feedback-card-body" styleName="feedback-card-body">
          {this.renderAppletFeedbackResponse()}
          <div>
            <div styleName="opinion-text">{text}</div>
            {feedbackType === "applet_feedback" &&
              like === false &&
              opinionCode && (
                <div>
                  <span>Reason: </span>
                  <span>{this.opinionCodeMap[opinionCode]}</span>
                </div>
              )}
          </div>
        </div>
        <Modal
          closeListener={this.toggleModal}
          show={this.state.modalOpen}
          headerText={"Report Abusive Feedback"}
          includeCloseX={false}
        >
          <div
            className="feeedback-card-modal"
            styleName="feeedback-card-modal"
          >
            <div
              className="feedback-modal-content"
              styleName="feedback-modal-content"
            >
              Are you sure you want to report this feedback?
            </div>
            <div
              className="modal-button-container"
              styleName="modal-button-container"
            >
              <button
                className="button-tertiary button-outlined"
                onClick={this.toggleModal}
              >
                Cancel
              </button>
              <button className="button-tertiary" onClick={this.reportFeedback}>
                Confirm
              </button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

PlatformFeedbackCard.propTypes = {
  feedbackType: PropTypes.string,
  id: PropTypes.number,
  createdAt: PropTypes.string,
  text: PropTypes.string,
  userLogin: PropTypes.string,
  profileImgUrl: PropTypes.string,
  channelInfo: PropTypes.shape({
    monochrome_image_url: PropTypes.string,
    brand_color: PropTypes.string,
    name: PropTypes.string,
  }),
  contextChannelPublished: PropTypes.bool,
  like: PropTypes.bool,
  opinionCode: PropTypes.string,
  userProfileLink: PropTypes.string,
}
